import type {
    AiTrackerReportsSourceAnalysisTableResponse,
    AiTrackerReportsSourceAnalysisUrlData,
} from "@similarweb/pro-api-client";

export enum MentionStatus {
    Mentioned = "mentioned",
    NotMentioned = "not_mentioned",
}

export interface IURLFilterState {
    searchTerm?: string;
    domainFilter?: string;
    changeFilter?: string[];
}

export type IAnalyzedURL = AiTrackerReportsSourceAnalysisUrlData;
export type IURLsResponse = AiTrackerReportsSourceAnalysisTableResponse;
